"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridEditRowsStateSelector = void 0;
/**
 * Select the row editing state.
 */
const gridEditRowsStateSelector = state => state.editRows;
exports.gridEditRowsStateSelector = gridEditRowsStateSelector;